import { h } from 'preact';
import PropTypes from 'prop-types';

import AutoPushNotifications from '../../containers/auto-push-notifications/auto-push-notifications';
import {
  autoPushNotificationsActions,
  autoPushNotificationsStore,
} from '../../../global-store/subjects/auto-push-notifications';
import { useSubscribe } from '../../hooks/use-subscribe';

export const AutoPushNotificationsComponent = ({ $root, htmlProps, widget }) => {
  const state = useSubscribe(autoPushNotificationsStore);
  return (
    <AutoPushNotifications
      htmlProps={htmlProps}
      widget={widget}
      $root={$root}
      state={state}
      actions={autoPushNotificationsActions}
    />
  );
};

AutoPushNotificationsComponent.propTypes = {
  htmlProps: PropTypes.object.isRequired,
  $root: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};
